import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import type React from 'react';
import { NAVY, RADIUS_COIN, SURFACE_CONTAINER_LOWEST } from 'styles/tokens';

import type { ExistenceFilterValue } from '../smartFilterTypes';

interface ExistenceToggleProps {
  value: ExistenceFilterValue;
  onChange: (value: ExistenceFilterValue) => void;
}

const TOGGLE_SX = {
  '& .MuiToggleButton-root': {
    fontFamily: 'Jost, sans-serif',
    fontSize: '0.8rem',
    fontWeight: 600,
    textTransform: 'none' as const,
    px: 2,
    py: 0.5,
    borderRadius: RADIUS_COIN,
    border: 'none',
    color: `${NAVY}80`,
    backgroundColor: SURFACE_CONTAINER_LOWEST,
    '&.Mui-selected': {
      backgroundColor: NAVY,
      color: '#fff',
      '&:hover': { backgroundColor: `${NAVY}dd` },
    },
    '&:hover': { backgroundColor: `${NAVY}08` },
  },
} as const;

const ExistenceToggle: React.FC<ExistenceToggleProps> = ({ value, onChange }) => {
  const handleChange = (_: React.MouseEvent<HTMLElement>, newValue: string | null) => {
    if (newValue === null) {
      onChange(null);
    } else {
      onChange(newValue === 'true');
    }
  };

  return (
    <ToggleButtonGroup
      value={value == null ? null : String(value)}
      exclusive
      onChange={handleChange}
      size="small"
      sx={TOGGLE_SX}
    >
      <ToggleButton value="true">Tiene valor</ToggleButton>
      <ToggleButton value="false">Está vacío</ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ExistenceToggle;
